import GatewayAxiosClient from '../GatewayAxiosClient';
import type { Limit, V2LimitSearchParams, ShipmentCountLimitSegmentParams } from './types';
import type {
  PartnerCostAdjustConfig,
  PartnerCostAdjustConfigCreate,
  PartnerCostAdjustConfigPatch,
  PartnerCostAdjustConfigPut,
  PartnerSearchCostAdjustParams,
  PartnerLimitCreateV2,
  PartnerLimitUpdateV2,
  PartnerLimitV2,
} from '@shipium-corp/shipium-ts-types';
export class LimitService {
  public async fetchPartnerCostingLimits(atDateTime: string = new Date().toISOString(), returnArchived = false) {
    const res = await GatewayAxiosClient.get(`/partner-management-proxy/api/v1/partners/carrierAccounts/limits`, {
      params: {
        atDateTime,
        limitType: 'recurring',
      },
    });
    return res.data.filter((val: any) => (returnArchived && val.active) || (val.archive === false && val.active));
  }

  public async fetchV2PartnerCostingLimits(atDateTime: string = new Date().toISOString(), returnArchived = false) {
    const res = await GatewayAxiosClient.get(`/partner-management-proxy/api/v2/partners/carrierAccounts/limitsV2`, {
      params: {
        atDateTime,
      },
    });
    return res.data.filter((val: any) => (returnArchived && val.active) || (val.archive === false && val.active));
  }
  public async createPartnerCostingLimit(limit: Limit) {
    const res = await GatewayAxiosClient.post(
      `/partner-management-proxy/api/v1/partners/carrierAccounts/limits`,
      limit,
    );
    return res.data;
  }
  public async updatePartnerCostingLimit(limitId: string, limit: Limit) {
    const res = await GatewayAxiosClient.put(
      `/partner-management-proxy/api/v1/partners/carrierAccounts/limits/${limitId}`,
      limit,
    );
    return res.data;
  }

  public async deleteLimit(limitId: string) {
    const res = await GatewayAxiosClient.delete(
      `/partner-management-proxy/api/v1/partners/carrierAccounts/limits/${limitId}`,
      {
        params: { isUserDecomission: true },
      },
    );
    return res.data;
  }
  public async fetchV2Limits(params: V2LimitSearchParams): Promise<PartnerLimitV2[]> {
    const res = await GatewayAxiosClient.get(`/partner-management-proxy/api/v2/partners/carrierAccounts/limitsV2`, {
      params,
    });
    return res.data;
  }
  public async getPartnerLimitV2(limitId: string): Promise<PartnerLimitV2> {
    const res = await GatewayAxiosClient.get(
      `/partner-management-proxy/api/v2/partners/carrierAccounts/limitsV2/${limitId}`,
    );
    return res.data;
  }
  public async createPartnerLimitV2(limit: PartnerLimitCreateV2): Promise<PartnerLimitV2> {
    const res = await GatewayAxiosClient.post(
      `/partner-management-proxy/api/v2/partners/carrierAccounts/limitsV2`,
      limit,
    );
    return res.data;
  }
  public async updatePartnerLimitV2(limitId: string, limit: PartnerLimitUpdateV2): Promise<PartnerLimitV2> {
    const res = await GatewayAxiosClient.put(
      `/partner-management-proxy/api/v2/partners/carrierAccounts/limitsV2/${limitId}`,
      limit,
    );
    return res.data;
  }
  public async getPartnerShipmentCountLimitSegmentInfo({ limitId, fromDate, toDate }: ShipmentCountLimitSegmentParams) {
    const res = await GatewayAxiosClient.get(
      `/partner-management-proxy/api/v2/partners/carrierAccounts/limitsV2/${encodeURIComponent(limitId)}/shipmentCountLimitSegmentInfo`,
      { params: { fromDate, toDate } },
    );
    return res.data;
  }
  // cost adjust config aka dynamic limits
  public async fetchCostAdjustConfigs(
    searchParams: PartnerSearchCostAdjustParams = {},
  ): Promise<PartnerCostAdjustConfig[]> {
    const params = Object.keys(searchParams).length ? { params: { ...searchParams } } : {};
    const res = await GatewayAxiosClient.get(`/partner-management-proxy/api/v1/partners/costAdjustConfig`, {
      ...params,
    });
    // temp filter archived records
    const data = res.data.filter((c: PartnerCostAdjustConfig) => c.archived === false);
    return data;
  }
  public async fetchCostAdjustConfig(costAdjustConfigId: string): Promise<PartnerCostAdjustConfig> {
    const res = await GatewayAxiosClient.get(
      `/partner-management-proxy/api/v1/partners/costAdjustConfig/${costAdjustConfigId}`,
    );
    return res.data;
  }
  public async createCostAdjustConfig(
    costAdjustConfig: PartnerCostAdjustConfigCreate,
  ): Promise<PartnerCostAdjustConfig> {
    const res = await GatewayAxiosClient.post(
      `/partner-management-proxy/api/v1/partners/costAdjustConfig`,
      costAdjustConfig,
    );
    return res.data;
  }
  public async updateCostAdjustConfig(
    costAdjustConfigId: string,
    costAdjustConfig: PartnerCostAdjustConfigPatch,
  ): Promise<PartnerCostAdjustConfig> {
    const res = await GatewayAxiosClient.patch(
      `/partner-management-proxy/api/v1/partners/costAdjustConfig/${costAdjustConfigId}`,
      costAdjustConfig,
    );
    return res.data;
  }
  public async putCostAdjustConfig(
    costAdjustConfigId: string,
    costAdjustConfig: PartnerCostAdjustConfigPut,
  ): Promise<PartnerCostAdjustConfig> {
    const res = await GatewayAxiosClient.put(
      `/partner-management-proxy/api/v1/partners/costAdjustConfig/${costAdjustConfigId}`,
      costAdjustConfig,
    );
    return res.data;
  }
}
